/**
 * Validated environment variables for the Tutor app.
 *
 * Import from here instead of reading import.meta.env directly.
 */

function requireEnv(name: string): string {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value as string;
}

export const CONVEX_URL = requireEnv('VITE_CONVEX_URL');
export const CLERK_PUBLISHABLE_KEY = requireEnv('VITE_CLERK_PUBLISHABLE_KEY');
